import React from "react";
import { css } from "@emotion/css";
import { DefaultButton, FontIcon, BaseButton, Button } from "@fluentui/react";

const styles = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;

  & h2 {
    margin: 16px 0;
    font-size: 3em;
    font-weight: 100;
    color: var(--main-font-color, black);
  }
`;

const iconClass = css`
  fontSize: 50,
  height: 50,
  width: 50,
  margin: '0 25px'
`;

export interface IPageHeadingProps {
  onClose?: (
    ev: React.MouseEvent<
      Button | HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | HTMLSpanElement,
      MouseEvent
    >
  ) => void;
  children: React.ReactNode;
}

const PageHeading = (props: IPageHeadingProps): JSX.Element => {
  const onClick = (
    ev: React.MouseEvent<
      Button | HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | HTMLSpanElement,
      MouseEvent
    >
  ) => {
    ev.stopPropagation();
    if (props.onClose) {
      props.onClose(ev);
    }
  };

  return (
    <div className={styles}>
      <h2>{props.children}</h2>
      {props.onClose ? (
        <DefaultButton onClick={onClick} ariaLabel="Go Back to Dashboard" title="Close Button">
          <FontIcon iconName="Cancel" className={iconClass} />
        </DefaultButton>
      ) : null}
    </div>
  );
};

export default PageHeading;
